import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function TruthSection() {
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-543">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-544">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-545">
          <div className="flex justify-center mb-6" data-id="element-546">
            <div className="bg-[#FFF9C4] p-4 rounded-full shadow-sm" data-id="element-547">
              <Lightbulb className="w-8 h-8 text-[#F57F17]" data-id="element-548" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-549">
            LA VERDAD QUE NADIE TE CUENTA
          </h2>

          <div className="space-y-6 text-gray-700 text-lg" data-id="element-550">
            <p data-id="element-551">
              Hay una razón muy concreta por la que esto pasa. Y no tiene que
              ver con que seas mala cocinera, ni con que tu hijo sea "difícil",
              ni con que la alimentación saludable sea imposible en la vida
              real.
            </p>

            <div className="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-[#4CAF50]" data-id="element-552">
              <p className="text-xl font-bold text-gray-900" data-id="element-553">
                Tiene que ver con el sistema. O más precisamente: con la falta
                de uno.
              </p>
            </div>

            <p data-id="element-554">
              Cuando decides qué cocinar cinco minutos antes de hacerlo, tu
              cerebro elige lo más fácil, lo más rápido, lo que ya conoce.
            </p>

            <p data-id="element-555">
              Cuando no hay estructura, hay caos. Y los niños —que necesitan
              predecibilidad para sentirse seguros— se defienden del caos con lo
              único que pueden controlar: lo que meten en la boca.
            </p>

            <div className="py-8" data-id="element-556">
              <div className="relative bg-[#E8F5E9] p-8 rounded-3xl text-center" data-id="element-557">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 text-4xl" data-id="element-558">
                  🧩
                </div>
                <p className="text-xl md:text-2xl font-bold text-[#2E7D32] italic" data-id="element-559">
                  "El rechazo en la mesa no suele ser sobre la comida. Es sobre
                  el control. Sobre la seguridad. Sobre la falta de rutina."
                </p>
              </div>
            </div>

            <p className="text-xl font-medium text-center text-gray-900" data-id="element-560">
              Y la buena noticia es que todo eso se puede cambiar,{' '}
              <span className="text-[#4CAF50] font-bold" data-id="element-561">
                sin ser nutricionista, sin pasar horas cocinando, y sin que la
                mesa sea un examen.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}